import { cn } from "@/lib/utils"
import React from "react"
import { Button, ButtonProps } from "@/components/ui/button"
import { Tooltip } from "@/components/ui/tooltip"

function PanelButton(
  props: ButtonProps & {
    label?: string | React.ReactNode
    tooltipPosition?: "top" | "bottom"
    tooltipClassName?: string
    tooltipDelay?: number
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  },
) {
  const { label, tooltipPosition, tooltipClassName, tooltipDelay, ...rest } = props
  return (
    <Tooltip
      tip={props.label}
      side={tooltipPosition || "bottom"}
      sideOffset={4}
      // openDelay={props.tooltipDelay}
      // className={props.tooltipClassName}
    >
      <Button
        variant={"ghost"}
        type="button"
        size="icon"
        {...rest}
        className={cn(`!size-10 min-h-0 min-w-0 [&_path]:!stroke-[2] [&_svg]:size-6`, rest.className)}
      >
        {props.children}
      </Button>
      {/* <ActionIcon
        size={40}
        color="dark"
        variant={"subtle"}
        type="button"
        {...rest}
        className={cn(
          `
            min-h-0 min-w-0

            [&_path]:stroke-[2]

            [&_svg]:size-6
          `,
          rest.className,
        )}
      /> */}
    </Tooltip>
  )
}

export default PanelButton
